var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShekel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89844 11.5469H14.7578C15.3099 11.5469 15.776 11.6094 16.1562 11.7344C16.5365 11.8594 16.8411 12.0547 17.0703 12.3203C17.3047 12.5807 17.4714 12.9141 17.5703 13.3203C17.6745 13.7214 17.7266 14.1979 17.7266 14.75V17.1641H15.4766V14.7422C15.4766 14.4401 15.4427 14.1953 15.375 14.0078C15.3073 13.8151 15.2083 13.6693 15.0781 13.5703C14.9531 13.4661 14.7995 13.3958 14.6172 13.3594C14.4401 13.3229 14.2422 13.3047 14.0234 13.3047H11.1484V20H8.89844V11.5469ZM16.5938 20H12.2656V14.375H14.5234V18.2422H17.3984C17.6901 18.2422 17.9453 18.2083 18.1641 18.1406C18.3828 18.0729 18.5521 17.9349 18.6719 17.7266C18.7917 17.5182 18.8516 17.2109 18.8516 16.8047V11.5469H21.1094V16.7969C21.1094 17.349 20.9792 17.8281 20.7188 18.2344C20.4583 18.6354 20.1094 18.9688 19.6719 19.2344C19.2396 19.4948 18.7552 19.6875 18.2188 19.8125C17.6875 19.9375 17.1458 20 16.5938 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekel);
export default __webpack_public_path__ + "static/media/shekel.e4b46826729dfbca53e14dad00ca161f.svg";
export { ForwardRef as ReactComponent };